import { call, put } from 'redux-saga/effects';
import { setUserDetails } from '../account/accountSlice';
import { requestGetBankBranches, requestGetBanks, requestSaveBankAccountDetails } from './bankDetailsFormRequests';
import {
  setBankAccountDetails,
  setBankBranches, setBankDetailsFormError, setBankDetailsFormStatus, setBanks,
} from './bankDetailsFormSlice';

export function* handleGetBanks(): Generator<any, any, any> {
  try {
    const response = yield call(
      requestGetBanks
    );
    const { data } = response;
    yield put(setBanks(data));
  } catch (error: any) {
    // eslint-disable-next-line no-console
    console.log(error);
    yield put(setBankDetailsFormError({
      isError: true,
      type: 'load_banks',
      message: error?.response?.data?.message || 'Something went wrong! Try again.',
    }));
  }
}

export function* handleGetBankBranches(action:any): Generator<any, any, any> {
  try {
    const response = yield call(
      requestGetBankBranches,
      { extendedUrl: `/${action.payload}` }
    );
    const { data } = response;
    if (data) {
      yield put(setBankBranches(data));
    }
  } catch (error: any) {
    // eslint-disable-next-line no-console
    console.log(error);
    yield put(setBankDetailsFormError({
      isError: true,
      type: 'load_bank_branches',
      message: error?.response?.data?.message,
    }));
  }
}

export function* handleSaveBankAccountDetails(action:any): Generator<any, any, any> {
  yield put(setBankDetailsFormStatus('loading'));
  try {
    const response = yield call(
      requestSaveBankAccountDetails,
      { ...action.payload }
    );
    const { data } = response;

    if (data.message) {
      yield put(setBankAccountDetails({ pan: action.payload.pan, dateOfBirth: action.payload.dateOfBirth }));
      yield put(setUserDetails(data.user));
    }
  } catch (error: any) {
    // eslint-disable-next-line no-console
    console.log(error);
    yield put(setBankDetailsFormError({
      isError: true,
      type: 'verify_pan',
      message: error?.response?.data?.message,
    }));
  }
}
